import moment from 'moment';
import { Positions } from '../../squad-database/api-types';

export interface MatchDataGridFormat {
  id: number;
  startDate: string;
  homeTeamName: string;
  visitingTeamName: string;
  round: number;
  status: string;
  result: string;
  matchConfig?: MatchConfig;
}

export interface MatchConfigHideStats {
  ballPossesion: boolean;
  distance: boolean;
}

export interface MatchConfigHidePlayerStats {
  maxSpeed: boolean;
  distance: boolean;
}

export interface MatchConfig {
  id: number;
  hideStats: MatchConfigHideStats;
  hidePlayerStats: Record<string, MatchConfigHidePlayerStats>;
  skipPush: boolean;
  showInterruptedMatchInformation: boolean;
  interruptedMatchText: string;
  hideMatchTime: boolean;
}

export interface MatchStats {
  homeCorners: number;
  homeFinishes: number;
  homeFreeKicks: number;
  homeOffsides: number;
  homeRedCards: number;
  homeShotsOnGoal: number;
  homeSubstitutions: number;
  homeYellowCards: number;
  visitingCorners: number;
  visitingFinishes: number;
  visitingFreeKicks: number;
  visitingOffsides: number;
  visitingRedCards: number;
  visitingShotsOnGoal: number;
  visitingSubstitutions: number;
}

export interface MatchEvent {
  key: string;
  gameTime: number;
  type: string;
  description: string;
  minuteWithStoppageTime: string;
  source: string;
  rating: number;
}

export interface LineupPlayer {
  fogisId: number;
  givenName: string;
  surName: string;
  id: string;
  imageHalf200: string;
  number: number;
  position: Positions;
  positionIndexFromBackRight: number;
}

export interface TeamLineup {
  formation: string;
  formationId: number;
  starting: LineupPlayer[];
  substitutes: LineupPlayer[];
}

export interface MatchMinimized {
  id: number;
  homeTeamName: string;
  homeTeamAbbrv: string;
  homeTeamLineup: TeamLineup;
  visitingTeamName: string;
  visitingTeamAbbrv: string;
  visitingTeamLineup: TeamLineup;
  round: number;
  status: string;
  startDate: Date;
  homeTeamScore: number;
  visitingTeamScore: number;
  arenaName: string;
  spectators: number;
  configLeagueName: string;
  configSeasonStartYear: number;
  leagueName: string;
  fogisId: number;
  stats: MatchStats;
  referees: string[];
  isAvailablePublicly: boolean;
  isBroadcastedByDiscovery: boolean;
  isBroadcastedByEurosport: boolean;
}

export interface Match extends MatchMinimized {
  matchEvents: MatchEvent[];
}

export const convertFirestoreMatchToDatagridFormat = (
  matchMinimized: MatchMinimized,
  matchConfigs?: MatchConfig[]
): MatchDataGridFormat => {
  const startDate = moment(matchMinimized.startDate).format('YYYY-MM-DD HH:mm');
  const { id, homeTeamName, homeTeamScore, visitingTeamName, visitingTeamScore, round, status } =
    matchMinimized;

  const foundMatchConfig = matchConfigs?.find(
    (matchConfig) => matchConfig.id === matchMinimized.id
  );

  return {
    id,
    startDate,
    homeTeamName,
    visitingTeamName,
    result: `${homeTeamScore} - ${visitingTeamScore}`,
    round,
    status,
    matchConfig: foundMatchConfig,
  };
};
